<div class="bottom-sheet-overlay" [class.nested]="editFleet" (click)="closePopup()">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back" (clicked)="closePopup()"></app-back-button>

        <h2 class="title">{{ editFleet ? 'Edit Fleet' : 'Create New Fleet' }}</h2>

        <app-confirm-button ariaLabel="Save" [loading]="isSaving" [disabled]="isSaving"
          (clicked)="saveFleet()"></app-confirm-button>
      </div>
    </div>

    <div class="content-scrollable">
      <!-- Fleet Name (required) -->
      <div class="form-group">
        <label>Fleet Name <span class="required-star">*</span></label>
        <input type="text" [(ngModel)]="fleetData.name" placeholder="Enter Fleet Name" />
      </div>

      <!-- Fleet Pic -->
      <div class="form-group center">
        <label>Fleet Pic</label>
        <div class="pic-uploader">
          <input type="file" #picInput hidden (change)="onFileSelected($event, 'pic')" accept="image/*" />
          <div class="pic-placeholder" *ngIf="!fleetPicPreview">
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="#AFCFFF">
              <!-- Sail -->
              <path d="M12 3 L12 16 L5 16 Z" />
              <!-- Second sail -->
              <path d="M13 6 L13 16 L19 16 Z" />
              <!-- Hull -->
              <path d="M4 17 Q12 21 20 17 L20 17 L4 17 Z" />
              <!-- Water line -->
              <path d="M2 19.5 Q7 17.5 12 19.5 Q17 21.5 22 19.5" fill="none" stroke="#AFCFFF" stroke-width="1.5"
                stroke-linecap="round" />
            </svg>
          </div>
          <img [src]="fleetPicPreview" class="pic-preview" *ngIf="fleetPicPreview" />
          <app-camera-button variant="profile" ariaLabel="Update fleet photo"
            (clicked)="triggerUpload('pic')"></app-camera-button>
        </div>
      </div>

      <!-- Fleet Category -->
      <div class="form-group">
        <label>Fleet Category</label>
        <div class="category-chips">
          <button *ngFor="let cat of categories" [class.active]="fleetData.category === cat" (click)="setCategory(cat)">
            <img class="cat-icon" [src]="getCategoryIcon(cat)" *ngIf="getCategoryIcon(cat)" alt="category icon" />
            <span class="cat-text">{{ cat }}</span>
          </button>
        </div>
      </div>

      <!-- Home Port (required) -->
      <div class="form-group">
        <label>Home Port <span class="required-star">*</span></label>
        <div class="home-port-wrapper">
          <input
            type="text"
            [(ngModel)]="homePortQuery"
            (ngModelChange)="onHomePortInput($event)"
            (blur)="hideHomePortDropdown()"
            placeholder="Search Home Port"
            autocomplete="off"
          />
          <svg class="home-port-pin" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <div class="home-port-dropdown" *ngIf="showHomePortDropdown && homePortResults.length > 0">
            <div
              class="home-port-option"
              *ngFor="let result of homePortResults"
              (mousedown)="selectHomePort(result)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#007aff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="option-pin">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span>{{ result.displayName }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Description -->
      <div class="form-group">
        <label>Description</label>
        <textarea [(ngModel)]="fleetData.description" placeholder="Enter Description (Optional)"></textarea>
      </div>

      <!-- Cover Photo -->
      <div class="form-group">
        <label>Cover Photo</label>
        <div class="cover-uploader" (click)="triggerUpload('cover')">
          <input type="file" #coverInput hidden (change)="onFileSelected($event, 'cover')" accept="image/*" />
          <div class="cover-placeholder" *ngIf="!coverPhotoPreview">
            <span class="plus-icon">+</span>
            <span class="cover-label">Add Cover Photo</span>
          </div>
          <img [src]="coverPhotoPreview" class="cover-preview" *ngIf="coverPhotoPreview" />
        </div>
      </div>

      <!-- Privacy Toggle -->
      <div class="form-group section-header">
        <!-- <label class="section-title">Privacy</label> -->
        <div class="toggle-row">
          <div class="toggle-info">
            <span class="toggle-label">Private Fleet</span>
            <p class="toggle-sub">Require admin approval for new members</p>
          </div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="fleetData.isPrivate" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <!-- Restrictive Sharing Toggle -->
      <div class="form-group section-header">
        <div class="toggle-row">
          <div class="toggle-info">
            <span class="toggle-label">Restrictive sharing</span>
            <p class="toggle-sub">Posts shared with this fleet cannot include other fleets or dockmates</p>
          </div>
          <div class="restrictive-toggle-right">
            <label class="switch">
              <input type="checkbox" [checked]="fleetData.isRestrictive"
                (click)="onRestrictiveClick($event)" />
              <span class="slider round"></span>
            </label>
            <button *ngIf="fleetData.isRestrictive" class="rules-info-btn" type="button" (click)="showRestrictiveRules()" title="View restriction rules">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="#0A84FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Welcome Message -->
      <div class="form-group">
        <label class="section-title">Welcome Message</label>
        <!-- <p class="subtitle">This message will be sent to new members</p> -->
        <textarea class="message-area" [(ngModel)]="fleetData.message"
          placeholder="Enter Welcome Message (Optional)"></textarea>
      </div>
    </div>
  </div>
</div>

<app-restrictive-acknowledgement-dialog
  *ngIf="showRestrictiveDialog"
  [mode]="restrictiveDialogMode"
  (agreed)="onRestrictiveAgreed()"
  (disagreed)="onRestrictiveDisagreed()"
  (closed)="onRestrictiveClosed()">
</app-restrictive-acknowledgement-dialog>